import React from 'react'
import { FormattedMessage } from 'react-intl'
import { accentuate, codify } from '../'
import {
    Section, Heading, UnorderedList, InlineCode,
    TableColumnHeader, TableRowHeader, TableCell
} from '../s'
import Paragraph from 'components/typography/paragraph'
import { ListItem } from 'components/list'
import { Table, TableHead, TableRow, TableBody } from 'components/table'

const WebhookUserSupportedFields = () => (
    <Section>
        <Heading>
            <FormattedMessage
                id="integration_heading_supported_fields"
                defaultMessage="Supported fields" />
        </Heading>
        <Paragraph>
            <FormattedMessage
                id="integration_webhook_preamble_supported_fields_profile"
                defaultMessage="These are the profile fields that the webhook will send updates about:" />
        </Paragraph>
        <Table>
            <TableHead>
                <TableRow>
                    <TableColumnHeader>
                        <FormattedMessage
                            id="noun_field"
                            defaultMessage="Field" />
                    </TableColumnHeader>
                    <TableColumnHeader>
                        <FormattedMessage
                            id="noun_json_key"
                            defaultMessage="JSON key" />
                    </TableColumnHeader>
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_emailaddress"
                            defaultMessage="Email address" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>email</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_birthdate"
                            defaultMessage="Date of birth" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>birthDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_type"
                            defaultMessage="Employment type" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>employmentType</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_percentage"
                            defaultMessage="Employment percentage" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>employmentPercentage</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_id"
                            defaultMessage="Employment ID" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>employmentId</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="noun_status"
                            defaultMessage="Status" />
                    </TableRowHeader>
                    <TableCell>
                        <Paragraph>
                            <FormattedMessage
                                id="integration_webhook_preamble_supported_field_status"
                                defaultMessage="<code>status</code> - either <code>ACTIVE</code> or <code>DEACTIVATED</code>."
                                values={{ code: codify }} />
                        </Paragraph>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_gender"
                            defaultMessage="Gender" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>gender</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_name_given"
                            defaultMessage="Given name" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>givenName</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_name_preferred"
                            defaultMessage="Preferred name" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>preferredName</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_name_family"
                            defaultMessage="Family name" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>familyName</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_nationality"
                            defaultMessage="Nationality" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>nationality</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_civilstatus"
                            defaultMessage="Civil status" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>civilStatus</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_dietary_requirements"
                            defaultMessage="Dietary restrictions" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>dietaryRequirements</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_email_personal"
                            defaultMessage="Personal email address" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>privateEmail</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_phonenumber"
                            defaultMessage="Phone number" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>phone</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_address_home"
                            defaultMessage="Address" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>address</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_financial_accountnumber"
                            defaultMessage="Bank account number" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>bankAccount</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_interests"
                            defaultMessage="Interests" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>interests</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_funfacts"
                            defaultMessage="Fun facts" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>funfacts</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_contract_date_start"
                            defaultMessage="Employment start date" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>employmentStartDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_date_start"
                            defaultMessage="First day of work" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>firstDayOfWork</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_probation_date_end"
                            defaultMessage="Probation end date" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>probationEndDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_termination_notice_date"
                            defaultMessage="Termination notice date" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>terminationNoticeDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_date_end"
                            defaultMessage="Last day of work" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>lastDayOfWork</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_termination_date"
                            defaultMessage="Employment end date" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>employmentEndDate</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_jobtitle"
                            defaultMessage="Job title" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>jobTitle</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_employment_jobdescription"
                            defaultMessage="Job description" />
                    </TableRowHeader>
                    <TableCell>
                        <InlineCode>jobDescription</InlineCode>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_label_supervisor"
                            defaultMessage="Supervisor" />
                    </TableRowHeader>
                    <TableCell>
                        <Paragraph>
                            <FormattedMessage
                                id="integration_webhook_preamble_supported_field_supervisor"
                                defaultMessage="<code>supervisor</code> - either <code>null</code> or an object containing the fields, <code>id</code> and <code>email</code>."
                                values={{ code: codify }} />
                        </Paragraph>
                        <UnorderedList>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_supervisor_id"
                                    defaultMessage="<code>id</code> is the supervisor’s user ID"
                                    values={{ code: codify }} />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_supervisor_email"
                                    defaultMessage="<code>email</code> is the supervisor’s email address"
                                    values={{ code: codify }} />
                            </ListItem>
                        </UnorderedList>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_pane_about_section_salary"
                            defaultMessage="Salary" />
                    </TableRowHeader>
                    <TableCell>
                        <Paragraph>
                            <FormattedMessage
                                id="integration_webhook_preamble_supported_field_salary"
                                defaultMessage="<code>salary</code> - an object containing the fields, <code>periodUnit</code>, <code>amount</code>, <code>currency</code>, <code>fromDate</code>, <code>toDate</code>, and optionally <code>note</code>."
                                values={{ code: codify }} />
                        </Paragraph>
                        <UnorderedList>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_salary_periodunit"
                                    defaultMessage="One of <code>hourly</code>, <code>weekly</code>, <code>monthly</code>, or <code>yearly</code>"
                                    values={{ code: codify }} />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_salary_amount"
                                    defaultMessage="A decimal number" />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_salary_currency"
                                    defaultMessage="An <strong>ISO 4217</strong> currency code"
                                    values={{ strong: accentuate }} />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_salary_range"
                                    defaultMessage="Dates, where the from date is always defined and the to date optional. Only the current salary is sent." />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_salary_note"
                                    defaultMessage="An optional field, containing free text" />
                            </ListItem>
                        </UnorderedList>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="person_pane_about_section_identifications"
                            defaultMessage="Identifications" />
                    </TableRowHeader>
                    <TableCell>
                        <Paragraph>
                            <FormattedMessage
                                id="integration_webhook_preamble_supported_field_identifications"
                                defaultMessage="<code>identifications</code> - an array of 0 or more objects, each of which include <code>type</code>, <code>country</code>, and <code>value</code>."
                                values={{ code: codify }} />
                        </Paragraph>
                        <UnorderedList>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_identifications_type"
                                    defaultMessage="<code>type</code> is either <code>passport</code> or <code>national</code>"
                                    values={{ code: codify }} />
                            </ListItem>
                            <ListItem>
                                <FormattedMessage
                                    id="integration_webhook_preamble_supported_field_identifications_country"
                                    defaultMessage="<code>country</code> is a two-letter <strong>ISO 3166-1 alpha-2</strong> code"
                                    values={{
                                        code: codify,
                                        strong: accentuate
                                    }} />
                            </ListItem>
                        </UnorderedList>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableRowHeader>
                        <FormattedMessage
                            id="profile_custom_fields_heading"
                            defaultMessage="Custom profile fields" />
                    </TableRowHeader>
                    <TableCell>
                        <Paragraph>
                            <FormattedMessage
                                id="integration_webhook_preamble_supported_field_custom"
                                defaultMessage="<code>custom.[name]</code> – the custom fields you’ve defined, formatted according to their types."
                                values={{ code: codify }} />
                        </Paragraph>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    </Section>
)

export default WebhookUserSupportedFields